import React, { useEffect, useRef, useState } from 'react';

import Header from "../../../../Components/Header/Header";
import LeftMenu from '../../../../Components/LeftMenu/LeftMenu';
import edit from "../../../../assets/images/edit.png";
import Trash from '../../../../assets/images/trash.png';
import Truck_p from '../../../../assets/images/truck_p.png';
import Info from "../../../../assets/images/info.png";
import Npackage from '../../../../assets/images/pack.png';
import Weight from '../../../../assets/images/weightn.png';
import Uldpic from '../../../../assets/images/puzzle.png';
import AddAWB from '../AWBMonitor/Components/AddAWB.js'
import CargoTruck from "../../../../assets/images/cargo-truck.png";
import BlueFlight from "../../../../assets/images/blueFlight.jpg";
import { faArrowLeft, faChevronDown, faGear, faPlus, faXmark, faExclamation, faAnglesLeft, faArrowRight, faCircleXmark, faInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Modal, Dropdown, ProgressBar, Row, Col } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import Box from "../../../../assets/images/box.png";
import TrashRed from "../../../../assets/images/trash_red.png";
import RedCross from "../../../../assets/images/close.png";
import { Link } from 'react-router-dom';
import Popup from 'reactjs-popup';
import Select from 'react-select';
import { toast } from 'react-toastify';
import blue_flight from "../../../../assets/images/plane.svg";
import Loader from '../../../../Components/common/Loader.js';
import { withRFSToken } from '../../../../Services/axios.js';
import { ADDPALLET, ASSIGNPALLET, BOOKINGTRUCKDETAILS, DELAWB, GETTYPECODE, PALLETLIST, REMOVEPALLET, ADDAWB } from '../../../../Utils/conts';
import AssignAWB from '../AWBMonitor/Components/AssignAWB.js';
import { fetchCondCode } from '../../../../redux/api/apiSlice.js';
import { CallApi, jqxCookieCall } from '../../../../Components/common/CommonFunctions.js';
const Planning = () => {

    const fileInputRef = useRef(null);
    const isFirstRender = useRef(true);
    let storedData = localStorage.getItem('BTDetails');
    if (storedData) {
        storedData = JSON.parse(storedData)
    }
    const [showPercentageModal, setShowPercentageModal] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState();
    const isMounted = useRef(false);
    const [isLoading, setIsLoading] = useState(true);
    const [gridSelect, setGridSelect] = useState([]);
    const [gridData, setGridData] = useState([]);
    const [colorStatus, setColorStatus] = useState();
    const [getTypeCodes, setGetTypeCodes] = useState([]);
    const [contourType, setContourType] = useState([]);
    const [filterApplied, setFilterApplied] = useState(false);
    const [loaderModal, setLoaderModal] = useState(false);
    const [totalPosition, setTotalPosition] = useState(0);
    const [palletSummary, setPalletSummary] = useState([]);
    const [totalUld, setTotalUld] = useState([]);
    // const [showEdit, setShowEdit] = useState(false);
    // const [editData, setEditData] = useState({});
    const [palletList, setPalletList] = useState([]);
    const deckType = [{ label: 'Main Decker', value: 'U' }, { label: 'Lower Decker', value: 'L' }]
    const positionOptions = [
        { label: '1', value: '1' },
        { label: '2', value: '2' },
        { label: '3', value: '3' },
        { label: '4', value: '4' }
    ];
    const palletOptions = [
        { label: '1', value: '1' },
        { label: '2', value: '2' },
        { label: '3', value: '3' },
        { label: '4', value: '4' }
    ];
    const [formData, setFormData] = useState({
        bookingtruck_id: storedData.bookingtruck_id, bookingtruck_date_id: storedData.bookingtruck_date_id, pallet_group_name: '', position: '', build_up: 'Y', contour_type: '', uld_type: '', no_pallet: '', max_height: ''
    })

    const loadDetails = async (number, dateid) => {
        try {
            const res = await withRFSToken.post(BOOKINGTRUCKDETAILS, { bookingtruck_id: number, bookingtruck_date_id: dateid, })
                .then(function (res) {
                    const innerData = res;
                    if (res.data.response_code == 200) {
                        setSelectedRowData(res.data.response_data);
                    }
                });

        } catch (error) {
            console.error('Error sending request:', error);
        }
    };

    const fetchTypeCode = async () => {
        try {

            const res = await withRFSToken.get('uld-types', {})
                .then(function (res) {
                    const innerData = res.data.Rows;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.uld_type,
                        label: item.uld_type,
                        id: item.id,
                        contours: item.contours,
                    })) : [];
                    setGetTypeCodes(transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchPalletList = async () => {
        try {
            const res = await withRFSToken.post(PALLETLIST, { bookingtruck_id: storedData.bookingtruck_id, bookingtruck_date_id: storedData.bookingtruck_date_id })
                .then(function (res) {
                    const innerData = res.data.response_data.pallet_groups;
                    setPalletList(innerData);
                    const totalPos = innerData?.reduce((total, row) => total + (parseFloat(row.position) || 0), 0);
                    setTotalPosition(totalPos);
                    const grouped = {};
                    let groupedCount = 0;
                    for (let i = 0; i < innerData.length; i++) {
                        const item = innerData[i];
                        const uld = item?.uld_type || "";
                        const contour = item?.contour?.contour || "";
                        const position = parseFloat(item?.no_pallet) || 0;
                        const key = uld + "|" + contour;
                        grouped[key] = (grouped[key] || 0) + position;
                    }
                    const summaryArr = Object.keys(grouped).map((key) => {
                        const [uld, contour] = key.split("|");

                        if (!uld) return null;

                        groupedCount += grouped[key];

                        return {
                            uld_type: uld,
                            contour: contour,
                            totalPosition: grouped[key],
                            label: `${uld} (${contour}) X ${grouped[key]}`,
                        };
                    }).filter(Boolean);
                    setPalletSummary(summaryArr);
                    setTotalUld(groupedCount);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        console.log(formData)
    }, [formData]);

    useEffect(() => {
        if (isMounted.current) return;
        loadDetails(storedData.bookingtruck_id, storedData.bookingtruck_date_id);
        fetchTypeCode();
        fetchPalletList();
        setIsLoading(false);
        setGridData([]);
        isMounted.current = true;
    }, []);
    const gridRef = useRef(null);

    const handleFormOnchange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value
        }));

    }

    const [dropChange, setDropChange] = useState();
    const [allData, setAllData] = useState();
    const [open, setOpen] = useState(false);

    // Grid
    let checkUlds = [];
    let filterForCheck = false;
    useEffect(() => {
        if (gridRef.current) {

            // var token = "Bearer " + localStorage.RFS;
            jqxCookieCall()
            const btid = storedData?.bookingtruck_date_id
            const ttrid = storedData?.bookingtruck_id
            const source = {
                url: `${process.env.REACT_APP_RFS_URL}get-assigned-awbs?bookingtruck_date_id=${btid}&bookingtruck_id=${ttrid}`,
                beforeSend: function (jqXHR) {
                    setLoaderModal(true);
                    // jqXHR.setRequestHeader('Authorization', token);
                },
                datatype: 'json',
                id: '',
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'awb_id', type: 'string' },
                    { name: 'airway_bill', type: 'string' },
                    { name: 'destination', type: 'string' },
                    { name: 'connection_time', type: 'string' },
                    { name: 'flight_number_join', type: 'string' },
                    { name: 'flight_code', type: 'string' },
                    { name: 'flight_number', type: 'string' },
                    { name: 'flight_date', type: 'string' },
                    { name: 'received', type: 'string' },
                    { name: 'weight', type: 'string' },
                    { name: 'volume', type: 'string' },
                    { name: 'commodity', type: 'string' },
                    { name: 'pallet_group_name', type: 'string' },
                    { name: 'pallet_groups', type: 'string' },
                    { name: 'bkd', type: 'string' },
                    { name: 'colour_status', type: 'string' },
                    { name: 'bookingtruck_date_id', type: 'string' },
                    { name: 'movements', type: 'string' },
                    { name: 'differtime', type: 'string' },
                    { name: 'import_export', type: 'string' },
                    { name: 'connection_flight', type: 'string' },
                    { name: 'ct', type: 'string' },
                    { name: 'origin', type: 'string' },
                    { name: 'rcs_dep', type: 'string' },
                    { name: 'pieces', type: 'string' },
                    { name: 'shc', type: 'string' },
                    { name: 'truck', type: 'string' },
                    { name: 'uld_number', type: 'string' },
                    { name: 'uld_contour', type: 'string' },
                    { name: 'uld_loadtype', type: 'string' },
                ],
                pagesize: 50,
                filter: function (allfilters) {
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRef.current).jqxGrid('clearselection');
                    window.$(gridRef.current).jqxGrid("updatebounddata", "filter");
                },
                beforeprocessing: function (data) {
                    setLoaderModal(false);
                    source.totalrecords = data.TotalRows;
                    const hasRorY = data.Rows?.some(item => item.colour_status === "R" || item.colour_status === "O");
                    setColorStatus(hasRorY);
                    setAllData(data);
                },
                sort: function (column, direction) {
                    window.$(gridRef.current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };
            const dataAdapter = new window.$.jqx.dataAdapter(source);
            const allRows = window.$(gridRef.current).jqxGrid('getrows');
            const palletGroups = [
                { label: 'tst', value: 'tst' },
                { label: 'Group B', value: 'B' },
                { label: 'Group C', value: 'C' },
            ];
            // let columns;

            // if (storedData?.booking_type == 'E') {
            let isEditorOpened = false;
            const columns = [
                {
                    text: 'Actions',
                    cellsrenderer: function () {
                        return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /> <img src="' + Trash + '" class="row_delete" /> <img src="' + Info + '" class="row_info" /></div>';
                    },
                    width: '6%', filterable: false,
                },
                {
                    text: 'Airway bill', filtertype: 'textbox', datafield: 'airway_bill', width: '12%', editable: false,
                    cellclassname: (row, column, value, rowData) => {
                        if (rowData.colour_status == 'G') {
                            return "awb_green";
                        } else if (rowData.colour_status == 'R') {
                            return "awb_red";
                        } else if (rowData.colour_status == 'O') {
                            return "awb_orange";
                        } else {
                            return;
                        }
                    },
                },
                {
                    text: 'Palletgroup', filtertype: 'textbox', datafield: 'pallet_group_name',
                    cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowdata) {
                        if (rowdata.pallet_group_name === null) {
                            return '<div class="jqx-grid-cell-left-align set_dock ">Please Select</div>';
                        }
                    },
                    columntype: 'dropdownlist',  // Set column type as dropdownlist
                    createeditor: function (row, cellvalue, editor) {
                        const rowData = window.$(gridRef.current).jqxGrid('getrowdata', row);
                        let palletGroups = rowData.pallet_groups || [];
                        console.log('palletGroups', palletGroups);
                        palletGroups = [{ label: 'Please Select', value: null }, ...palletGroups];
                        editor.jqxDropDownList({
                            source: palletGroups.map(item => ({ label: item.label, value: item.value })),
                            autoDropDownHeight: true,
                            displayMember: 'label',
                            valueMember: 'value',
                            placeHolder: 'Please select',
                        });
                        let previousValue = cellvalue;
                        isEditorOpened = false;
                        editor.on('change', (event) => {

                            const selectedItem = event.args.item;
                            if (selectedItem && isEditorOpened) {
                                const rowData = window.$(gridRef.current).jqxGrid('getrowdata', row);
                                const newValue = selectedItem.label;
                                // if (newValue !== previousValue) {
                                if (rowData) {
                                    rowData.pallet_group_name = selectedItem.label;  // Update row data with label
                                    rowData.pallet_group_id = selectedItem.value;
                                    window.$(gridRef.current).jqxGrid('updaterow', row, rowData);
                                    setDropChange(rowData);
                                }
                            }
                        });
                    },
                    initeditor: function (row, cellvalue, editor) {
                        editor.jqxDropDownList('selectItem', cellvalue);
                        editor.jqxDropDownList('open');
                        isEditorOpened = true;
                    },
                    geteditorvalue: function (row, cellvalue, editor) {
                        const selectedValue = editor.jqxDropDownList('getSelectedItem');
                        return selectedValue ? selectedValue.label : null;
                    },
                    width: '12%', cellclassname: 'raarrow', editable: true
                },
                // { text: 'Import / Export', filtertype: 'textbox', datafield: 'import_export', width: '9%', cellclassname: '', editable: false },
                { text: 'Connected Flight', filtertype: 'textbox', datafield: 'connection_flight', width: '12%', cellclassname: '', editable: false },
                { text: 'CT', filtertype: 'textbox', datafield: 'connection_time', width: '6%', cellclassname: '', editable: false },
                { text: 'Origin', filtertype: 'textbox', datafield: 'origin', width: '6%', cellclassname: '', editable: false },
                { text: 'Destination', filtertype: 'textbox', datafield: 'destination', width: '6%', cellclassname: '', editable: false },
                { text: 'SHC', filtertype: 'textbox', datafield: 'shc', width: '12%', cellclassname: '', editable: false },
                { text: 'Pieces', filtertype: 'textbox', datafield: 'pieces', width: '5%', cellclassname: '', editable: false },
                { text: 'Volume', filtertype: 'textbox', datafield: 'volume', width: '7%', cellclassname: '', editable: false },
                { text: 'Weight', filtertype: 'textbox', datafield: 'weight', width: '5%', cellclassname: '', editable: false },
                { text: 'ULD No', filtertype: 'textbox', datafield: 'uld_number', width: '8%', cellclassname: '', },
                { text: 'ULD Contour', filtertype: 'textbox', datafield: 'uld_contour', width: '9%', cellclassname: '', },
                { text: 'ULD Load Type', filtertype: 'textbox', datafield: 'uld_loadtype', width: '10%', cellclassname: '', },
                // {
                //     text: 'RCS / DEP',
                //     width: '7%',
                //     filterable: false,
                //     cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties, rowData) {
                //         const pieces = parseFloat(rowData.pieces) || 0;
                //         const rcs = parseFloat(rowData.rcs_total_pieces_awb) || 0;
                //         let displayValue = `<div class="" style="margin-top: 13.5px;"><img src='${RedCross}' alt='Not Received' title='Not Received' /></div>`;
                //         if (rcs > 0) {
                //             displayValue = `${rcs} / ${pieces}`;
                //         }
                //         return `<div class="" style="margin-top: 13.5px;">${displayValue}</div>`;
                //     },
                // },


                // { text: 'Truck', filtertype: 'textbox', datafield: 'truck', width: '9%', cellclassname: '', editable: false },


                // { text: 'CT', filtertype: 'textbox', datafield: 'connection_time', width: '9%', cellclassname: '', editable: false },

                // { text: 'Flight', filtertype: 'textbox', datafield: 'flight_number_join', width: '9%', cellclassname: '', editable: false },
                // { text: 'RCS', filtertype: 'textbox', datafield: 'received', width: '9%', cellclassname: '', editable: false },
                // { text: 'Pieces', filtertype: 'textbox', datafield: 'pieces', width: '5%', cellclassname: '', editable: false },
                // { text: 'Volume', filtertype: 'textbox', datafield: 'volume', width: '5%', cellclassname: '', editable: false },
                // { text: 'Weight', filtertype: 'textbox', datafield: 'weight', width: '5%', cellclassname: '', editable: false },
                // { text: 'SHC', filtertype: 'textbox', datafield: 'shc', width: '9%', cellclassname: '', editable: false },
                // { text: 'Truck', filtertype: 'textbox', datafield: 'truck', width: '9%', cellclassname: '', editable: false },
                // { text: 'Commodity', filtertype: 'textbox', datafield: 'commodity', width: '9%', cellclassname: '', },

            ];
            // } else {
            //     columns = [
            //         {
            //             text: 'Actions',
            //             cellsrenderer: function () {
            //                 return '<div className="grid_actions"><img src="' + edit + '" className="row_edit" /> <img src="' + Trash + '" className="row_delete" /></div>';
            //             },
            //             width: '6%', filterable: false,
            //         },
            //         { text: 'BKD', filtertype: 'textbox', datafield: 'bkd', width: '9%', cellclassname: '', },
            //         { text: 'Airway bill', filtertype: 'textbox', datafield: 'airway_bill', width: '10%', cellclassname: '', },
            //         { text: 'Pieces', filtertype: 'textbox', datafield: 'pieces', width: '9%', cellclassname: '', },
            //         { text: 'Weight', filtertype: 'textbox', datafield: 'weight', width: '9%', cellclassname: '', },
            //         { text: 'Volume', filtertype: 'textbox', datafield: 'volume', width: '9%', cellclassname: '', },
            //         { text: 'SHC', filtertype: 'textbox', datafield: 'shc', width: '9%', cellclassname: '', },
            //         { text: 'Commodity', filtertype: 'textbox', datafield: 'commodity', width: '9%', cellclassname: '', },
            //     ];
            // }
            const nestedColumns = [
                { text: 'Pieces', datafield: 'pieces', width: '14%' },
                { text: 'Weight', datafield: 'weight', width: '14%' },
                { text: 'Length', datafield: 'length', width: '14%' },
                { text: 'Width', datafield: 'width', width: '14%' },
                { text: 'Height', datafield: 'height', width: '14%' },
                { text: 'Stackable', datafield: 'stackable', width: '14%' },
                { text: 'Rotatable', datafield: 'rotatable', width: '14%' },
            ];
            const nestedGrids = {};
            const initrowdetails = (index, parentElement, gridElement, record) => {
                const nestedGridContainer = parentElement.children[0];
                const parentRowId = record.uid.toString();
                nestedGrids[parentRowId] = nestedGridContainer;
                parentElement.addEventListener('click', (event) => {
                    const target = event.target;
                    if (window.$(target).hasClass('jqx-icon-arrow-right')) {
                        event.stopPropagation();
                    }
                });
                const id = record.uid.toString();
                const uldGrid = Array.isArray(record.package_information)
                    ? record.package_information
                    : (record.package_information ? [record.package_information] : []);
                const nestedSource = {
                    datatype: 'array',
                    id: 'shipmentChildID',
                    datafields: [
                        { name: 'pieces', type: 'string' },
                        { name: 'weight', type: 'string' },
                        { name: 'length', type: 'string' },
                        { name: 'width', type: 'string' },
                        { name: 'height', type: 'string' },
                        { name: 'stackable', type: 'string' },
                        { name: 'rotatable', type: 'string' },
                    ],
                    localdata: uldGrid,
                }
                const nestedDataAdapter = new window.$.jqx.dataAdapter(nestedSource);
                const nestedGridOptions = {
                    width: '90%',
                    pageable: false,
                    sortable: false,
                    autoheight: true,
                    height: (10 * 45),
                    selectionmode: 'none',
                    source: nestedDataAdapter,
                    filterable: false,
                    columns: nestedColumns,
                    rowdetails: true,
                    rowsheight: 45,
                    showemptyrow: false,
                    ready: function () {
                        const rows = window.$(nestedGridContainer).jqxGrid('getrows');
                        for (let i = 0; i < rows.length; i++) {
                            const rowid = i;
                            const row = rows[i];
                            window.$(nestedGridContainer).jqxGrid('setcellvalue', row.uid, 'uid', rowid);
                            window.$(nestedGridContainer).jqxGrid('updaterow', rowid, row);
                            window.$(nestedGridContainer).find(`[role="row"][row-id="${row.uid}"]`).attr('row-id', rowid);
                        }
                    },
                };
                window.$(nestedGridContainer).jqxGrid(nestedGridOptions);

            };
            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 1040,
                sortable: true,
                altrows: false,
                columnsresize: false,
                enabletooltips: false,
                editable: true,
                selectionmode: 'checkbox',
                initrowdetails: initrowdetails,
                pageable: true,
                pageSize: 50,
                //pagesizeoptions: ['50', '100', '200', '500'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                showstatusbar: true,
                rowdetails: true,
                virtualmode: true,
                rowdetailstemplate: {
                    rowdetails: '<div id="nestedGrid" style="margin: 10px;"></div>',
                    rowdetailsheight: (5 * 45),
                    rowdetailshidden: true,
                },
                rendergridrows: function (params) {
                    return params.data;
                },
                rendered: function () {
                    const rows = window.$(gridRef.current).jqxGrid('getrows');
                    (checkUlds).forEach(uldNumber => {
                        rows.forEach((element, index) => {
                            if (element.uld_number == uldNumber) {
                                window.$(gridRef.current).jqxGrid('selectrow', index);
                            }
                        });
                    });
                }
            };

            // const gridOptions = {
            //     width: '100%',
            //     source: dataAdapter,
            //     columns: columns,
            //     autoheight: false,
            //     height: 1040,
            //     sortable: true,
            //     altrows: false,
            //     columnsresize: false,
            //     enabletooltips: false,
            //     editable: true,
            //     selectionmode: 'checkbox',
            //     pageable: true,
            //     pageSize: 50,
            //     // pagesizeoptions: ['50', '100', '200', '500'],
            //     pagerButtonsCount: 5,
            //     pagerMode: 'advanced',
            //     filterable: true,
            //     filterrowheight: 45,
            //     showfilterrow: true,
            //     rowsheight: 42,
            //     columnsheight: 45,
            //     showstatusbar: true,
            //     virtualmode: true,
            //     rendergridrows: function (params) {
            //         return params.data;
            //     },
            //     rendered: function () {
            //         const rows = window.$(gridRef.current).jqxGrid('getrows');
            //         (checkUlds).forEach(uldNumber => {
            //             rows.forEach((element, index) => {
            //                 if (element.uld_number == uldNumber) {
            //                     window.$(gridRef.current).jqxGrid('selectrow', index);
            //                 }
            //             });
            //         });
            //     }
            // };
            window.$(gridRef.current).jqxGrid(gridOptions);
            attachDelegatedTooltipHandlers();
            window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');

            window.$(gridRef.current).on('dragover', (event) => {
                event.preventDefault(); // Allow drop

            });

            window.$(gridRef.current).on('drop', (event) => {
                event.preventDefault();
                const droppedData = JSON.parse(event.originalEvent.dataTransfer.getData('text/plain'));
                console.log('Dropped Data:', droppedData); // Process your dropped data here

                // Example: Update grid or handle logic based on dropped data
                // You can add logic here to update the grid or do something with the dropped data.
            });

            window.$(gridRef.current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });

            });
            window.$(gridRef.current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow.awb_id;
                    const selectedRowId = selectedRow.uid;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }
                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.awb_id === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRef.current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }

            });
            window.$(gridRef.current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.awb_id;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.awb_id !== unselectedRowId));
                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                }

            });
            window.$(gridRef.current).on('click', '.row_edit', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
                // const dataToSend = {
                //     uld_number: rowData.uld_number,
                //     type_code: rowData.type_code,
                //     serial_number: rowData.serial_number,
                //     owner_code: rowData.owner_code,
                //     condition_code: rowData.condition_code,
                //     asset_type: rowData.asset_type
                // };
                handleEditModalOpen('E', rowData);
                // setEditData(dataToSend);
                // setShowEdit(true);

            });
            window.$(gridRef.current).on('click', '.row_delete', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);

                handleModalOpen('G', rowData.awb_id);

            });
            window.$(gridRef.current).off('cellclick');
            window.$(gridRef.current).on('cellclick', (event) => {
                const args = event.args.row.bounddata;
                if (event.args.columnindex > 1) {

                    if (gridSelect) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                        // setGridSelect([]);
                    }
                    // loadDetails(args.uld_number);
                }

            });
        }
    }, [gridData]);
    let $customTooltip = null;
    function ensureTooltipDiv() {
        if (!$customTooltip) {
            $customTooltip = window.$('<div id="custom-awb-tooltip" />').css({
                position: 'absolute',
                'z-index': 999999,
                display: 'none',
                'max-width': '480px',
                'overflow-y': 'auto',
                'overflow-x': 'hidden',
                'max-height': '50vh',
            }).appendTo('body');
        }
    }
    function formatTime(timeStr) {
        if (!timeStr) return '';
        const parts = timeStr.split(':');
        if (parts.length >= 2) {
            const hours = parts[0].padStart(2, '0');
            const minutes = parts[1].padStart(2, '0');
            return `${hours}:${minutes}`;
        }
        return timeStr;
    }
    function buildTooltipHtml(data) {
        if (!data) return '<div>No data</div>';
        let htmlContent = '';
        const movements = Array.isArray(data.movements) ? data.movements : (data.movements ? [data.movements] : []);
        const differtime = Array.isArray(data.differtime) ? data.differtime : (data.differtime ? [data.differtime] : []);
        if (movements.length > 0) {
            if (Array.isArray(movements)) {
                let departureDate = null;
                let departureTime = null;
                let previousArrival = null;
                movements.forEach(element => {
                    let imageFile = null;
                    let Boardpoint = '';
                    let Offpoint = '';
                    let allDateTime = null;
                    let connectionTime = null;
                    // if (element.type === 'Flight') {

                    //     let arrivalDate = element.flight_schedule?.arrival_date_utc.split(' ')[0] ?? null;
                    //     let arrivalTime = element.flight_schedule?.arrival_date_utc.split(' ')[1] ?? null;
                    //     let connectionTime=(departureDate departureTime) - (arrivalDate arrivalTime)
                    //     imageFile = BlueFlight;
                    //     Boardpoint = element.flight_schedule?.origin;
                    //     Offpoint = element.flight_schedule?.destination;
                    //     allDateTime = element.flight_schedule;
                    //     departureDate = element.flight_schedule?.departure_date_utc.split(' ')[0] ?? null;
                    //     departureTime = element.flight_schedule?.departure_date_utc.split(' ')[1] ?? null;
                    // } else if (element.type === 'Truck') {
                    //     let arrival_date = element.booking_truck_date_detail?.arrival_date;
                    //     let arrival_time = element.booking_truck_date_detail?.arrival_time;
                    //     let connectionTime=(departureDate departureTime) - (arrivalDate arrivalTime)
                    //     imageFile = CargoTruck;
                    //     Boardpoint = element.booking_truck_date_detail?.booking_truck_details?.board_point_station?.station_code;
                    //     Offpoint = element.booking_truck_date_detail?.booking_truck_details?.off_point_station?.station_code || '';
                    //     allDateTime = element.booking_truck_date_detail;
                    //     departureDate = element.booking_truck_date_detail?.departure_date;
                    //     departureTime = allDateTime?.departure_time;
                    // }
                    if (element.type === 'Flight') {
                        let arrivalDateTime = element.flight_schedule?.arrival_date_utc ?? null;
                        let departureDateTime = element.flight_schedule?.departure_date_utc ?? null;

                        let arrivalDate = arrivalDateTime ? arrivalDateTime.split(' ')[0] : null;
                        let arrivalTime = arrivalDateTime ? arrivalDateTime.split(' ')[1] : null;
                        let depDate = departureDateTime ? departureDateTime.split(' ')[0] : null;
                        let depTime = departureDateTime ? departureDateTime.split(' ')[1] : null;

                        // Calculate connection time (difference between previous arrival and current departure)
                        if (previousArrival && depDate && depTime) {
                            // let prev = new Date(previousArrival);
                            // let curr = new Date(`${depDate}T${depTime}`);
                            // let diffMinutes = (curr - prev) / (1000 * 60); // in minutes
                            // if (diffMinutes >= 0) connectionTime = formatMinutesToHHMM(diffMinutes);
                            let prev = new Date(previousArrival);
                            let curr = new Date(`${depDate}T${depTime}`);
                            let diffMinutes = (curr - prev) / (1000 * 60);
                            connectionTime = (diffMinutes >= 0 ? '' : '-') + formatMinutesToHHMM(Math.abs(diffMinutes));
                        }

                        imageFile = BlueFlight;
                        Boardpoint = element.flight_schedule?.origin;
                        Offpoint = element.flight_schedule?.destination;
                        allDateTime = element.flight_schedule;
                        previousArrival = arrivalDateTime ? `${arrivalDate}T${arrivalTime}` : null;
                        departureDate = depDate;
                        departureTime = depTime;
                    }
                    else if (element.type === 'Truck') {
                        let arrivalDate = element.booking_truck_date_detail?.arrival_date;
                        let arrivalTime = element.booking_truck_date_detail?.arrival_time;
                        let depDate = element.booking_truck_date_detail?.departure_date;
                        let depTime = element.booking_truck_date_detail?.departure_time;

                        if (previousArrival && depDate && depTime) {
                            let prev = new Date(previousArrival);
                            let curr = new Date(`${depDate}T${depTime}`);
                            let diffMinutes = (curr - prev) / (1000 * 60); // in minutes
                            if (diffMinutes >= 0) connectionTime = formatMinutesToHHMM(diffMinutes);
                        }

                        imageFile = CargoTruck;
                        Boardpoint = element.booking_truck_date_detail?.booking_truck_details?.board_point_station?.station_code;
                        Offpoint = element.booking_truck_date_detail?.booking_truck_details?.off_point_station?.station_code || '';
                        allDateTime = element.booking_truck_date_detail;
                        previousArrival = arrivalDate && arrivalTime ? `${arrivalDate}T${arrivalTime}` : null;
                        departureDate = depDate;
                        departureTime = depTime;
                    }
                    let className = "";
                    if (connectionTime) {
                        const [hours, minutes] = connectionTime.split(':').map(Number);
                        if (hours < 10) {
                            className = "error_connection_tym";
                        } else {
                            className = "success_connection_tym";
                        }
                        htmlContent += `<div class='${className} d-flex justify-content-between'><span>Connection Time -</span>
                                                                <span>${connectionTime}</span></div>`;
                    }
                    // if (differtime) {
                    //     differtime.forEach(differtimeElement => {
                    //         if (element.id == differtimeElement.id && element.sequence == differtimeElement.sequence) {

                    //         }
                    //     });
                    // }


                    htmlContent += `
                                        <div class='route_segment_list'>
                                            <h6>${element.flight_truck_no} / ${element.date}</h6>
                                            <div class='Boardpoint_offpoint_dv d-flex justify-content-between align-items-center'>
                                                <div class='boardpoint_station'>
                                                    <p>Boardpoint</p>
                                                    <h5>${Boardpoint || ''}</h5>
                                                </div>`;
                    // htmlContent += `
                    //     <div class='flight_details'>
                    //         <p class='flign_no_tym'><span>DEP:</span> ${allDateTime?.departure_date || allDateTime?.departure_date_utc + " " + formatTime(allDateTime?.departure_time) || ''}</p>
                    //         <img src='${imageFile} alt='cargo_truck'/>
                    //         <p class='flign_no_tym'><span>ARR:</span>   ${allDateTime?.arrival_date || allDateTime?.arrival_date_utc + " " + formatTime(allDateTime?.arrival_time) || ''}</p>
                    //     </div>`;

                    if (element.type === 'Truck') {
                        htmlContent += `
                                                    <div class='flight_details'>
                                                        <p class='flign_no_tym'><span>DEP:</span> ${element.booking_truck_date_detail?.departure_date + " " + formatTime(element.booking_truck_date_detail?.departure_time) || ''}</p>
                                                        <img src='${CargoTruck} alt='cargo_truck'/>
                                                        <p class='flign_no_tym'><span>ARR:</span>   ${element.booking_truck_date_detail?.arrival_date + " " + formatTime(element.booking_truck_date_detail?.arrival_time) || ''}</p>
                                                    </div>`;

                    } else if (element.type === 'Flight') {
                        htmlContent += `
                                                    <div class='flight_details'>
                                                        <p class='flign_no_tym'> <span>DEP:</span> ${element.flight_schedule?.departure_date_utc || ''}</p>
                                                        <img src='${BlueFlight}'  class="blueflight" alt='blue_flight'/>
                                                        <p class='flign_no_tym'> <span>ARR:</span> ${element.flight_schedule?.arrival_date_utc || ''}</p>
                                                    </div>`;
                        Offpoint = element.flight_schedule?.destination;
                    }

                    htmlContent += `
                                                <div class='offpoint_station'>
                                                    <p>Offpoint</p>
                                                    <h5>${Offpoint || ''}</h5>
                                                </div>
                                            </div>
                                        </div>`
                });
            }
        } else {
            htmlContent += "<span>No Data Is Available For This AWB</span>";
        }
        let tooltipHtml = "<div class='pallet_hv route_shipment_segment_dv'>";
        if (movements.length > 0) {
            tooltipHtml += "<h5><span>" + data.airway_bill + " -</span> <span>Route Shipment</span></h5>";
        }
        tooltipHtml += htmlContent;
        tooltipHtml += "</div>";
        return tooltipHtml;
    }

    const formatMinutesToHHMM = (minutes) => {
        const hrs = Math.floor(minutes / 60);
        const mins = Math.floor(minutes % 60);
        return `${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}`;
    };
    // function attachDelegatedTooltipHandlers() {
    //     const $grid = window.$(gridRef.current);
    //     if (!$grid || !$grid.length) return;
    //     ensureTooltipDiv();
    //     $grid.off('mouseenter.customTooltip', '.row_info');
    //     $grid.off('mousemove.customTooltip', '.row_info');
    //     $grid.off('mouseleave.customTooltip', '.row_info');
    //     $grid.on('mouseenter.customTooltip', '.row_info', function (e) {
    //         const $el = window.$(this);
    //         const rowDiv = $el.closest('[role="row"]');
    //         const rowIndex = rowDiv.attr('row-id');
    //         let data = null;
    //         try {
    //             data = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex) || {};
    //         } catch (err) {
    //             data = {};
    //         }
    //         const html = buildTooltipHtml(data);
    //         $customTooltip.html(html).show();
    //         const pageX = e.pageX || (e.originalEvent && e.originalEvent.pageX) || 0;
    //         const pageY = e.pageY || (e.originalEvent && e.originalEvent.pageY) || 0;
    //         const tooltipWidth = $customTooltip.outerWidth();
    //         const tooltipHeight = $customTooltip.outerHeight();
    //         const windowWidth = window.innerWidth;
    //         const windowHeight = window.innerHeight;
    //         const scrollTop = window.scrollY || document.documentElement.scrollTop;
    //         const scrollLeft = window.scrollX || document.documentElement.scrollLeft;
    //         let left = pageX + 16;
    //         let top = pageY + 16;
    //         if (left + tooltipWidth > windowWidth + scrollLeft) {
    //             left = pageX - tooltipWidth - 16;
    //             if (left < scrollLeft + 8) left = scrollLeft + 8; // clamp to viewport
    //         }
    //         const spaceBelow = windowHeight + scrollTop - (pageY + 16);
    //         const spaceAbove = pageY - scrollTop - 16;
    //         if (spaceBelow < tooltipHeight && spaceAbove > tooltipHeight) {
    //             top = pageY - tooltipHeight - 16;
    //         }
    //         if (top < scrollTop + 8) {
    //             top = scrollTop + 8;
    //         }
    //         if (top + tooltipHeight > windowHeight + scrollTop) {
    //             top = windowHeight + scrollTop - tooltipHeight - 8;
    //         }
    //         $customTooltip.css({
    //             left: left + 'px',
    //             top: top + 'px'
    //         });
    //     });
    //     $grid.on('mousemove.customTooltip', '.row_info', function (e) {
    //         if (!$customTooltip) return;
    //         const pageX = e.pageX || (e.originalEvent && e.originalEvent.pageX) || 0;
    //         const pageY = e.pageY || (e.originalEvent && e.originalEvent.pageY) || 0;
    //         const tooltipWidth = $customTooltip.outerWidth();
    //         const tooltipHeight = $customTooltip.outerHeight();
    //         const windowWidth = window.innerWidth;
    //         const windowHeight = window.innerHeight;
    //         const scrollTop = window.scrollY || document.documentElement.scrollTop;
    //         const scrollLeft = window.scrollX || document.documentElement.scrollLeft;
    //         let left = pageX + 16;
    //         let top = pageY + 16;
    //         if (left + tooltipWidth > windowWidth + scrollLeft) {
    //             left = pageX - tooltipWidth - 16;
    //             if (left < scrollLeft + 8) left = scrollLeft + 8; // clamp to viewport
    //         }
    //         const spaceBelow = windowHeight + scrollTop - (pageY + 16);
    //         const spaceAbove = pageY - scrollTop - 16;
    //         if (spaceBelow < tooltipHeight && spaceAbove > tooltipHeight) {
    //             top = pageY - tooltipHeight - 16;
    //         }
    //         if (top < scrollTop + 8) {
    //             top = scrollTop + 8;
    //         }
    //         if (top + tooltipHeight > windowHeight + scrollTop) {
    //             top = windowHeight + scrollTop - tooltipHeight - 8;
    //         }
    //         $customTooltip.css({
    //             left: left + 'px',
    //             top: top + 'px'
    //         });
    //     });
    //     $grid.on('mouseleave.customTooltip', '.row_info', function () {
    //         if ($customTooltip) $customTooltip.hide();
    //     });
    //     $grid.off('scroll.customTooltip').on('scroll.customTooltip', function () {
    //         if ($customTooltip) $customTooltip.hide();
    //     });
    // }

    function attachDelegatedTooltipHandlers() {
        const $grid = window.$(gridRef.current);
        if (!$grid || !$grid.length) return;

        ensureTooltipDiv();

        let tooltipHover = false;
        let cellHover = false;

        // Handle hover events on the tooltip itself
        $customTooltip
            .off('mouseenter.tooltipHover mouseleave.tooltipHover')
            .on('mouseenter.tooltipHover', function () {
                tooltipHover = true;
            })
            .on('mouseleave.tooltipHover', function () {
                tooltipHover = false;
                if (!cellHover) $customTooltip.hide();
            });

        // Remove old handlers to prevent duplicates
        $grid.off('mouseenter.customTooltip mousemove.customTooltip mouseleave.customTooltip scroll.customTooltip');

        // Mouse enter on grid cell
        $grid.on('mouseenter.customTooltip', '.row_info', function (e) {
            cellHover = true;

            const $el = window.$(this);
            const rowDiv = $el.closest('[role="row"]');
            const rowIndex = rowDiv.attr('row-id');
            let data = null;

            try {
                data = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex) || {};
            } catch (err) {
                data = {};
            }

            const html = buildTooltipHtml(data);
            $customTooltip.html(html).show();

            positionTooltip(e);
        });

        // Mouse move to reposition tooltip dynamically
        $grid.on('mousemove.customTooltip', '.row_info', function (e) {
            positionTooltip(e);
        });

        // Mouse leave on grid cell
        $grid.on('mouseleave.customTooltip', '.row_info', function () {
            cellHover = false;
            setTimeout(() => {
                if (!tooltipHover) $customTooltip.hide();
            }, 150); // small delay to allow moving into tooltip
        });

        // Hide tooltip on grid scroll
        $grid.on('scroll.customTooltip', function () {
            if ($customTooltip) $customTooltip.hide();
        });

        // Helper function to handle tooltip positioning
        function positionTooltip(e) {
            const pageX = e.pageX || (e.originalEvent && e.originalEvent.pageX) || 0;
            const pageY = e.pageY || (e.originalEvent && e.originalEvent.pageY) || 0;
            const tooltipWidth = $customTooltip.outerWidth();
            const tooltipHeight = $customTooltip.outerHeight();
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const scrollTop = window.scrollY || document.documentElement.scrollTop;
            const scrollLeft = window.scrollX || document.documentElement.scrollLeft;

            let left = pageX + 16;
            let top = pageY + 16;

            // Prevent tooltip from going off screen horizontally
            if (left + tooltipWidth > windowWidth + scrollLeft) {
                left = pageX - tooltipWidth - 16;
                if (left < scrollLeft + 8) left = scrollLeft + 8;
            }

            // Adjust vertical position (flip if not enough space below)
            const spaceBelow = windowHeight + scrollTop - (pageY + 16);
            const spaceAbove = pageY - scrollTop - 16;
            if (spaceBelow < tooltipHeight && spaceAbove > tooltipHeight) {
                top = pageY - tooltipHeight - 16;
            }

            // Clamp top position within viewport
            if (top < scrollTop + 8) top = scrollTop + 8;
            if (top + tooltipHeight > windowHeight + scrollTop)
                top = windowHeight + scrollTop - tooltipHeight - 8;

            $customTooltip.css({
                left: left + 'px',
                top: top + 'px'
            });
        }
    }


    const [notArea, setNotArea] = useState();
    const [rowId, setRowId] = useState();
    const handleDeleteRow = async () => {
        try {
            const res = await withRFSToken.post(DELAWB, { awb_id: rowId })
                .then(function (res) {
                    const innerData = res.data;
                    // console.log("🚀 ~ .then ~ innerData:", innerData)
                    if (res.data.response_code === 200) {
                        fetchPalletList();
                        setTimeout(() => {
                            setIsLoading(false);
                            window.$(gridRef.current).jqxGrid('updatebounddata');
                        }, 1);
                    }

                });

        } catch (error) {
            console.error('Error sending request:', error);
        }
    }

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (dropChange?.pallet_group_id == null) {
            handlePalletGroupChange('Y')
        } else {
            handlePalletGroupChange()
        }

    }, [dropChange])

    const handlePalletGroupChange = async (status = null, chk) => {
        let awbIds = [];
        if (gridSelect.length > 0) {
            awbIds = gridSelect && gridSelect.map(row => row.awb_id);
        } else {
            awbIds = [dropChange?.awb_id];
        }
        let dataToSend = gridSelect.length > 0 ? gridSelect : [dropChange];
        if (!status) {
            const percentage = checkVolume(dataToSend);
            if (percentage > 100) {
                setShowPercentageModal(true);
                return;
            }
        }
        const payload = {
            pallet_group_id: dropChange?.pallet_group_id,
            awb_ids: awbIds
        }
        try {
            const res = await withRFSToken.post(ASSIGNPALLET, payload)
                .then(function (res) {
                    const innerData = res.data.response_data;
                    fetchPalletList();
                    setShowPercentageModal(false);
                    setIsLoading(false);
                    setGridData([]);
                    setGridSelect([]);
                    window.$(gridRef.current).jqxGrid('clearselection');
                    if (res.data.response_code === 200) {
                        // fetchPalletList();
                        // setShowPercentageModal(false);
                        // setIsLoading(false);
                        // setGridData([]);
                        // setGridSelect([]);
                        // window.$(gridRef.current).jqxGrid('clearselection');
                    } else {
                        toast.error(res.data.response_msg);
                    }
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const checkVolume = (allDataArray) => {
        const palletGroupId = dropChange?.pallet_group_id;
        const volume1 = allDataArray.reduce((sum, item) => sum + (parseFloat(item.volume) || 0), 0);

        // Get total volume for palletGroupId2
        const volume2 = allData?.Rows?.filter(item => item.pallet_group_id === palletGroupId).reduce((sum, item) => sum + (parseFloat(item.volume) || 0), 0);

        // Add both
        const totalVolume = volume1 + volume2;
        // const totalVolume = allData?.Rows?.filter(item => item.pallet_group_id === palletGroupId).reduce((sum, item) => sum + (parseFloat(item.volume) || 0), 0) || 0;
        const pallet = palletList.find(p => p.pallet_group_id === dropChange?.pallet_group_id);
        const availableVolume = pallet ? pallet.available_valume : 0;
        const percentage = (totalVolume / availableVolume) * 100;
        return percentage;
    }

    const handleSop = async () => {
        // console.log('55555', gridSelect);
        // const bookingTruckIds = gridSelect.map(item => item.bookingtruck_date_id.toString());
        const bookingTruckIds = storedData.bookingtruck_date_id;
        try {
            const res = await withRFSToken.post('awb-acknowledge-changes', { bookingtruck_date_id: bookingTruckIds })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    if (res.data.response_code === 200) {
                        toast.success(res.data.response_msg)
                        setGridData([]);
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                        setGridSelect([]);
                        reloadGridData()
                        fetchPalletList();
                    }
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    // Modal
    const [show, setShow] = useState(false);
    const [modalMode, setModalMode] = useState(null);
    // const [palletEditData, setPalletEditData] = useState(null);
    const handleShow = (e) => { setModalMode(e); setShow(true); };
    const handleClose = () => {
        setShow(false);
        setFormData({
            bookingtruck_id: storedData.bookingtruck_id, bookingtruck_date_id: storedData.bookingtruck_date_id, pallet_group_name: '', position: '', build_up: 'Y', contour_type: '', uld_type: '', no_pallet: '', max_height: ''
        })
    };
    const validateFormData = () => {
        let isValid = true;

        if (!formData.pallet_group_name) {
            toast.error('Please set Pallet Group Name');
            isValid = false;
        }
        else if (!formData.position) {
            toast.error('Please select Position');
            isValid = false;
        }
        else if (formData.build_up === 'Y') {
            if (!formData.contour_type) {
                toast.error('Please set Contour Type');
                isValid = false;
            } else if (!formData.uld_type) {
                toast.error('Please set ULD Type');
                isValid = false;
            } else if (!formData.no_pallet) {
                toast.error('Please set Number Pallet');
                isValid = false;
            } else if (!formData.max_height) {
                toast.error('Please set Max Height');
                isValid = false;
            }
        } else {
            return isValid;
        }
        return isValid;
    };
    const addPalletGroup = async () => {
        if (validateFormData()) {
            console.log("formdata===>", formData);
            const finalData = {

            }
            try {
                const res = await withRFSToken.post(ADDPALLET, formData)
                    .then(function (res) {
                        const innerData = res.data;
                        // console.log("🚀 ~ .then ~ innerData:", innerData)
                        if (res.data.response_code === 200) {
                            fetchPalletList();
                            handleClose();
                            setTimeout(() => {
                                setIsLoading(false);
                                window.$(gridRef.current).jqxGrid('updatebounddata');
                            }, 1);
                        } else {
                            toast.error(res.data.response_msg);
                        }

                    });

            } catch (error) {
                console.error('Error sending request:', error);
            }
        }
    }

    const editPalletGroup = async (e, data) => {
        const selectedType = getTypeCodes.find(item => item.value === data.uld_type);
        setContourType(
            selectedType?.contours?.map(c => ({
                value: c.id,
                label: c.contour
            })) || []
        );
        setModalMode(e);
        setShow(true);
        const transformedData = {
            ...data,
            build_up: data.build_up === "Yes" ? "Y" : "N",
        }
        setFormData(transformedData);
    }

    const [showEditModal, setShowEditModal] = useState(false);
    const [editmodalData, setEditModalData] = useState();
    const [availableScheduleTruck, setAvailableScheduleTruck] = useState();
    const [gridSelectData, setGridSelectData] = useState();
    const [confirmModal, setConfirmModal] = useState(false);
    const [selectedTrucks, setSelectedTrucks] = useState({
        bookingtruck_date_id: '',
        departure_date: ''
    });
    const getAvailableScheduleTruck = async () => {
        try {
            const res = await withRFSToken.post('get-available-schedule-trucks', { bookingtruck_id: storedData.bookingtruck_id, bookingtruck_date_id: storedData.bookingtruck_date_id })
                .then(function (res) {
                    const innerData = res;
                    // console.log("🚀 ~ .then ~ innerData:", innerData)
                    if (res.data.response_code == 200) {
                        setAvailableScheduleTruck(res.data.response_data);
                    }
                });

        } catch (error) {
            console.error('Error sending request:', error);
        }
    }
    const [reAssignShow, setReAssignShow] = useState(false);
    const handleEditModalOpen = (e, item) => {
        if (e == 'Assign') {
            if (gridSelect.length === 0) {
                toast.error('Please select at least one Airway Bill to reassign')
            } else {
                // setShowEditModal(true);
                getAvailableScheduleTruck();
                setReAssignShow(true);
                setGridSelectData(gridSelect);
                setModalMode(e);
                const keysToRemove = ['Assign AWB'];
                keysToRemove.forEach(key => localStorage.removeItem(key));

                const storageData = { AWB: gridSelect, BTS: {} };
                // saveAndNavigate(action, storageData);
                localStorage.setItem(item, JSON.stringify(storageData));
            }
        } else {
            setModalMode(e);
            setShowEditModal(true);
            setEditModalData(item);
        }
    };
    const reAssignHandleClose = () => {
        setReAssignShow(false);
        setGridSelect([]);
        setGridSelectData([]);
        window.$(gridRef?.current).jqxGrid('clearselection');
    };
    const handleDeleteAwb = (index) => {
        setGridSelectData((prev) => prev.filter((_, i) => i !== index));
    };

    const handleTruckSelect = (bookingtruck_date_id, date) => {
        setSelectedTrucks({
            bookingtruck_date_id,
            date
        });
    };

    const handleReassign = async (conf) => {
        if (selectedTrucks.bookingtruck_date_id != '' && selectedTrucks.departure_date != '') {
            if (conf == "yes") {
                const updatedFormData = {
                    AWB: gridSelectData,
                    BTS: selectedTrucks,
                    action_confirm: "yes",
                    // action_confirm: conf ? conf : null,
                };
                try {
                    const res = await withRFSToken.post(ADDAWB, updatedFormData)
                        .then(function (res) {
                            const innerData = res.data.response_data;
                            if (res.data.response_code === 200 || res.data.response_code === 220) {
                                // setConfirmModal(true);
                                if (conf == "yes") {
                                    setConfirmModal(false);
                                    setReAssignShow(false);
                                    // setGridSelectData([]);
                                    setGridSelect([]);
                                    toast.success(res.data.response_msg);
                                    window.$(gridRef.current).jqxGrid('clearselection');
                                    window.$(gridRef.current).jqxGrid('refresh');
                                    window.$(gridRef.current).jqxGrid('updatebounddata');
                                    setSelectedTrucks({
                                        bookingtruck_date_id: '',
                                        departure_date: ''
                                    });
                                }
                            } else {
                                toast.error(res.data.response_msg);
                            }
                        });

                } catch (error) {
                    console.error('Error fetching data:', error);
                }
            } else {
                setConfirmModal(true);
            }
        } else {
            toast.error('Please select a Truck to reassign the AWB(s)');
        }
    };

    const confirmModalClose = () => {
        setConfirmModal(false);
    }
    useEffect(() => {
        if (gridSelectData?.length == 0) {
            setReAssignShow(false);
        }
    }, [gridSelectData]);
    const handleEditModalClose = () => { setShowEditModal(false); };

    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState();
    const handleModalClose = () => { setShowModal(false); setModalData(); };
    const handleModalOpen = (area, item) => {
        setNotArea(area);
        if (area === 'P') {
            setModalData(item);
        } else if (area === 'G') {
            setRowId(item);
        }
        setShowModal(true);

    };
    const handleConfirmation = (confirm) => {
        if (confirm) {
            if (notArea === 'P') {
                deletePalletGroup();
            } else if (notArea === 'G') {
                handleDeleteRow();
            } else if (notArea === 'A') {
                handleSop();
            }
            setShowModal(false);
        } else {
            setShowModal(false);
            setModalData();
        }
    };

    const deletePalletGroup = async () => {
        // console.log("formdata===>", modalData.pallet_group_id);
        try {
            const res = await withRFSToken.post(REMOVEPALLET, { pallet_group_id: modalData.pallet_group_id })
                .then(function (res) {
                    const innerData = res.data;
                    // console.log("🚀 ~ .then ~ innerData:", innerData)
                    if (res.data.response_code === 200) {
                        fetchPalletList();
                        setTimeout(() => {
                            setIsLoading(false);
                            window.$(gridRef.current).jqxGrid('updatebounddata');
                        }, 1);
                    }

                });

        } catch (error) {
            console.error('Error sending request:', error);
        }
    };
    const reloadGridData = () => {
        setTimeout(() => {
            setIsLoading(false);
            window.$(gridRef.current).jqxGrid('updatebounddata');
        }, 1);
    }

    const resetFilters = () => {
        window.$(gridRef.current).jqxGrid('clearfilters');
    };

    const handlePercentageModalClose = () => {
        setShowPercentageModal(false);
        setIsLoading(false);
        setGridData([]);
        setGridSelect([]);
    };
    return (

        <div className="">
            <Header logo_url='/BookingtruckSchedule' />
            <div className="schedule">
                <LeftMenu />
                <div className='main-panel'>
                    <Row>
                        <Col ms={6}>
                            <Link to={'/BookingtruckDetails'} className='stk_back'> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link>
                        </Col>
                        <Col ms={6}>
                            <div className='bkd_ttv text-end'>
                                <span className="me-2">Total Volume: {(allData?.total_volume)}</span>
                                <span>Total Weight: {(allData?.total_weight)}</span>
                            </div>
                        </Col>
                    </Row>
                    <div className="mt-3 nestedtabs rounded">
                        <div className='d-flex justify-content-between'>
                            <div className='viewbook'>
                                <h4>Bookingtruck - {selectedRowData?.bookingtruck_no}</h4>
                                <p><b>Date :</b> {selectedRowData?.date} <span style={{ marginLeft: '10px', marginRight: '10px', }}><b>Boardpoint :</b> {selectedRowData?.boardpoint} </span> <b>Offpoint :</b> {selectedRowData?.offpoint}</p>
                            </div>
                            <div className='d-flex align-items-center'>
                                {colorStatus && <Link to='#' className='me-3 ac_changes' onClick={() => handleModalOpen('A')}> <FontAwesomeIcon icon={faExclamation} /> Acknowledge Changes</Link>}
                                <div className='me-3'>
                                    <button className="truck_planing" variant="primary" onClick={() => { window.location.href = '/BookingtruckDetails/TruckPlanning' }}>
                                        <span> <img src={Truck_p} /> Truck Planning</span>
                                    </button>
                                </div>
                                <Dropdown>
                                    <Dropdown.Toggle variant="light" id="dropdown-basic" className='action'>
                                        <FontAwesomeIcon icon={faGear} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item onClick={() => handleEditModalOpen('Assign', 'Assign AWB')}> Reassign</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    </div>
                    <div className='maindiv'>
                        <div className='SecondDiv uld-dv mt-3'>
                            <div className='d-flex justify-content-between add_pallt pl-uld'>
                                <h3>Total Positions</h3>
                                <h3>{totalPosition}</h3>
                            </div>
                            <div className='d-flex justify-content-between add_pallt pl-uld'>
                                <h3>Total ULDs</h3>
                                <h3>{totalUld}
                                    <Popup trigger={<span className='pallet_list'>
                                        <Link to='#'><img src={Info} alt="Info" /></Link>
                                    </span>} position="right top" on={['hover', 'focus']}>
                                        <div className='right-pop'>
                                            <h3>Total ULDs </h3>
                                            {palletSummary.map((row, index) => (
                                                <h3 key={index}>{row.label}</h3>
                                            ))}
                                        </div>

                                    </Popup>
                                </h3>
                            </div>
                            <div className='new_pallet'>
                                <div className='d-flex justify-content-between add_pallt'>
                                    <h3>Load Groups</h3>
                                    <Link to='#' onClick={() => handleShow('A')}><FontAwesomeIcon icon={faPlus} /> Add Load Group</Link>
                                </div>
                                <div style={{ position: 'relative' }}>
                                    {palletList?.map((item, index) => (
                                        <>
                                            <Popup key={index} trigger={<div className='pallet_list'>
                                                <div className='d-flex justify-content-between name_pallet'>
                                                    <h3>{item.pallet_group_name}</h3>
                                                    <span><Link to='#' onClick={() => editPalletGroup('E', item)}><img src={edit} /> </Link> <Link to='#' onClick={() => handleModalOpen('P', item)}> <img src={Trash} /></Link> </span>
                                                </div>
                                                <div className='d-flex justify-content-between align-items-center'>
                                                    <div className='pl_position'>
                                                        <div className='pl_item'> <img src={Uldpic} /> <span> {item.position}</span> </div>
                                                        <div className='pl_item'> <img src={Npackage} /> <span> {item.pieces || 0}</span> </div>
                                                        <div className='pl_item'> <img src={Weight} /> <span> {item.weight || 0}</span> </div>
                                                    </div>
                                                    <div className='prbar'>
                                                        <div className={item.capacity_utilization == 0
                                                            ? 'bg-gray'
                                                            : (item.capacity_utilization > 0 && item.capacity_utilization <= 50)
                                                                ? 'bg-red'
                                                                : (item.capacity_utilization > 50 && item.capacity_utilization <= 75)
                                                                    ? 'bg-orange'
                                                                    : 'bg-green'
                                                        }>
                                                            <div className="progress" style={{ position: 'relative' }}>
                                                                <div className="progress-bar progress-bar-striped" role="progressbar" style={{ width: `${item.capacity_utilization}%` }} aria-valuenow={item.capacity_utilization} aria-valuemin="0" aria-valuemax="100"></div>
                                                            </div>
                                                            <span className='bar_text'>{item.capacity_utilization}%</span>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>} position="right top" on={['hover', 'focus']}>

                                                <div className='pallet_hv'>
                                                    <h4>{item.pallet_group_name}</h4>
                                                    <div className="d-flex justify-content-between rabord">
                                                        <div className="firstbrd"><p>Min CT</p><span>{item.min_ct}</span></div>
                                                        <div className="middlebrd"><p></p></div>
                                                        <div className="lastbrd"><p>Max CT</p><span>{item.max_ct}</span></div>
                                                    </div>
                                                    <div className='hovrbar'>
                                                        <p>Capacity Utilization</p>
                                                        <div className='prbar w-100'>
                                                            <div className={
                                                                item.capacity_utilization == 0
                                                                    ? 'bg-gray'
                                                                    : (item.capacity_utilization > 0 && item.capacity_utilization <= 50)
                                                                        ? 'bg-red'
                                                                        : (item.capacity_utilization > 50 && item.capacity_utilization <= 75)
                                                                            ? 'bg-orange'
                                                                            : 'bg-green'
                                                            }>
                                                                <div className="progress" style={{ position: 'relative' }}>
                                                                    <div className="progress-bar progress-bar-striped" role="progressbar" style={{ width: `${item.capacity_utilization}%` }} aria-valuenow={item.capacity_utilization} aria-valuemin="0" aria-valuemax="100"></div>
                                                                </div>
                                                                <span className='bar_text'>{item.capacity_utilization || 0}%</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <ul>
                                                            <li>
                                                                <p>Volume</p>
                                                                <span>{item.volume || '-'}</span>
                                                            </li>
                                                            <li>
                                                                <p>Weight</p>
                                                                <span>{item.weight || '-'}</span>
                                                            </li>
                                                            <li className='w-100'>
                                                                <p>SHC</p>
                                                                <span>{item.shc || '-'}</span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div>
                                                        <ul>
                                                            <li>
                                                                <p>Positions</p>
                                                                <span>{item.position}</span>
                                                            </li>
                                                            <li>
                                                                <p>Build Up</p>
                                                                <span>{item.build_up}</span>
                                                            </li>
                                                            <li>
                                                                <p>Contour Type</p>
                                                                <span>{item?.contour?.contour || '-'}</span>
                                                            </li>
                                                            <li>
                                                                <p>Type</p>
                                                                <span>{item.uld_type || '-'}</span>
                                                            </li>
                                                            <li className='w-100'>
                                                                <p>Max. Height (CM)</p>
                                                                <span>{item.max_height || '-'}</span>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    {/* <p>Volume : {item.details?.volume}</p>
                                                <p>Weight : {item.details?.weight}</p>
                                                <p>SHC : {item.details?.SHC?.join(', ')}</p> */}
                                                </div>
                                            </Popup>
                                        </>
                                    ))}
                                </div>
                            </div>


                        </div>
                        <div className='trashdonload mt-3 position-relative'>
                            <div className=''>
                                {/* {!isLoading && <div ref={gridRef} className='bookinggrid' ></div>} */}
                                {!isLoading && <>
                                    {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                                    <div ref={gridRef} className='bookinggrid' ></div>
                                </>
                                }
                            </div>
                        </div>
                        <div className="mt-3 shipmentChanges d-flex bg-white">
                            <div className="mainDiv" onClick={() => setOpen(!open)} style={{ cursor: 'pointer' }}>
                                <h4 className="writing-vertical m-0">
                                    <span>Shipment Changes</span>
                                    <FontAwesomeIcon icon={faAnglesLeft} className={`mt-2 transition-icon ${open ? "rotated" : ""}`} />
                                </h4>
                            </div>
                            <div className={`shipmentChangesContainer ${open ? "opened" : "closed"}`}>

                                <h3>Shipment Changes</h3>
                                <p className='text-muted'>Changes detected in assigned shipment</p>

                                {allData?.changes?.changed_data?.length > 0 && (
                                    <div className="change_ship">
                                        <h5 className='awb_orange position-relative'>Changed Shipments</h5>
                                        {allData?.changes.changed_data.map((change, index) => (
                                            <div className="changesItem p-2" key={index}>
                                                <h6 className="mb-0">{change.old_data.airway_bill}</h6>
                                                {Object.entries(change.differences).map(([field, values], idx) => (
                                                    <p className="mb-0" key={idx}>
                                                        <label>
                                                            {field.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                                                        </label>
                                                        : <span> {values.old}</span>
                                                        <FontAwesomeIcon icon={faArrowRight} />
                                                        <span> {values.new}</span>
                                                    </p>
                                                ))}
                                            </div>
                                        ))}
                                    </div>
                                )}
                                {allData?.changes?.new_airway_bills?.length > 0 && (
                                    <div className="change_ship">
                                        <h5 className='awb_green position-relative'>New Shipments</h5>
                                        {allData?.changes.new_airway_bills.map((change, index) => (
                                            <div className='remv_ship'>
                                                <div className="changesItem p-2" key={index}>
                                                    <h6 className="mb-0"><span className='new_one'>New</span>{change}</h6>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                                {allData?.changes?.deleted_airway_bills?.length > 0 && (
                                    <div className="change_ship">
                                        <h5 className='awb_red position-relative'>Removed Shipments</h5>
                                        {allData?.changes.deleted_airway_bills.map((change, index) => (
                                            <div className='remv_ship'>
                                                <div className="changesItem p-2" key={index}>
                                                    <h6 className="mb-0"><span><FontAwesomeIcon icon={faCircleXmark} /></span>{change}</h6>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <Modal show={show} onHide={handleClose} centered className='addfrom add_plt book_sdl'>
                <Modal.Header closeButton>
                    <Modal.Title>{modalMode === 'E' ? 'Edit' : 'Add'} Load Group</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
                            <Form.Label>Load Group Name</Form.Label>
                            <Form.Control name='pallet_group_name' value={formData.pallet_group_name} onChange={handleFormOnchange} placeholder='Load Group Name' />
                        </Form.Group>

                        <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
                            <Form.Label>No. Positions</Form.Label>
                            {/* <Form.Control name='position' value={formData.position} onChange={handleFormOnchange} placeholder='No. Positions' /> */}
                            <Select
                                options={positionOptions}
                                onChange={(selected) => {
                                    setFormData({ ...formData, position: selected.value });
                                }}
                                placeholder="No. of Positions"
                                className='autoslct'
                                name="position"
                                value={positionOptions.find(option => option.value === String(formData.position))}
                            />
                        </Form.Group>
                        <div className="mb-2">
                            <Form.Label> Build Up</Form.Label>
                            <div className="d-flex">
                                <Form.Check
                                    inline
                                    label="Yes"
                                    name="build_up"
                                    type="radio"
                                    id="yes"
                                    value="Y"
                                    checked={formData.build_up === 'Y'}
                                    onChange={handleFormOnchange}

                                />
                                <Form.Check
                                    inline
                                    label="No"
                                    name="build_up"
                                    type="radio"
                                    id="no"
                                    value="N"
                                    checked={formData.build_up === 'N'}
                                    onChange={handleFormOnchange}
                                />
                            </div>
                        </div>

                        {formData.build_up === 'Y' &&
                            <>
                                <div className="mb-2">
                                    <div className="row">
                                        {/* <div className="col-md-6">
                                            <Form.Group controlId="exampleForm.ControlInput1">
                                                <Form.Label>Deck Type</Form.Label>
                                                <Select
                                                    options={deckType}
                                                    onChange={(selected) => {
                                                        setFormData({ ...formData, deck_type: selected.value });
                                                    }}
                                                    placeholder="Deck Type"
                                                    className='autoslct'
                                                    name="deck_type"
                                                    value={deckType.find(option => option.value === formData.deck_type)}
                                                />
                                            </Form.Group>
                                        </div> */}
                                        <div className="col-md-6">
                                            <Form.Group controlId="exampleForm.ControlInput2">
                                                <Form.Label>ULD Type</Form.Label>
                                                <Select
                                                    options={getTypeCodes}
                                                    onChange={(selected) => {
                                                        setFormData(prevFormData => {
                                                            const newFormData = { ...prevFormData, uld_type: selected.value, contour_type: '' }
                                                            return newFormData;
                                                        });
                                                        setContourType(selected.contours.map(item => ({
                                                            value: item.id,
                                                            label: item.contour
                                                        })));
                                                    }}
                                                    placeholder="ULD Type"
                                                    className='autoslct'
                                                    name="uld_type"
                                                    value={getTypeCodes.find(option => option.value === formData.uld_type)}
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-md-6">
                                            <Form.Group controlId="exampleForm.ControlInput2">
                                                <Form.Label>Contour Type</Form.Label>
                                                <Select
                                                    options={contourType}
                                                    onChange={(selected) => {
                                                        setFormData(prevFormData => {
                                                            const newFormData = { ...prevFormData, contour_type: selected.value }
                                                            return newFormData;
                                                        });
                                                    }}
                                                    placeholder="Contour Type"
                                                    className='autoslct'
                                                    name="contour_type"
                                                    value={contourType.find(option => option.value === formData.contour_type) || ''}
                                                />
                                            </Form.Group>
                                        </div>
                                    </div>
                                </div>
                                <div className="mb-2">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <Form.Group controlId="exampleForm.ControlInput1">
                                                <Form.Label>No. pallets</Form.Label>
                                                {/* <Form.Control
                                                    name="no_pallet"
                                                    value={formData.no_pallet}
                                                    onChange={handleFormOnchange}
                                                    placeholder="No. pallets"
                                                /> */}
                                                <Select
                                                    options={palletOptions}
                                                    onChange={(selected) => {
                                                        setFormData({ ...formData, no_pallet: selected.value });
                                                    }}
                                                    placeholder="No. of pallets"
                                                    className='autoslct'
                                                    name="no_pallet"
                                                    value={palletOptions.find(option => option.value === String(formData.no_pallet))}
                                                />
                                            </Form.Group>
                                        </div>
                                        <div className="col-md-6">
                                            <Form.Group controlId="exampleForm.ControlInput2">
                                                <Form.Label>Max. Height</Form.Label>
                                                <Form.Control
                                                    type='number'
                                                    name="max_height"
                                                    value={formData.max_height}
                                                    onChange={handleFormOnchange}
                                                    placeholder="Max. Height"
                                                />
                                            </Form.Group>
                                        </div>
                                    </div>
                                </div>
                            </>

                        }
                        <Form.Group className="mb-2" controlId="remarks">
                            <Form.Label>Remarks</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                name="remarks"
                                value={formData.remarks || ''}
                                onChange={handleFormOnchange}
                                placeholder="Enter any remarks here..."
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={addPalletGroup} >
                        {modalMode === 'E' ? 'Update' : 'Add'} Palletgroup
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showModal} onHide={handleModalClose} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    {notArea === 'A' ?
                        <>
                            <h3>Acknowledge Changes.</h3>
                            <p>Are you sure you want to Acknowledge the shipment Changes?</p>
                        </>
                        :
                        <>
                            <h3>All changes will be destroyed.</h3>
                            <p>If you proceed with the change, all data in this section will be removed.
                                Are you sure you want to continue?</p>
                        </>
                    }

                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="secondary" onClick={() => handleConfirmation(false)}>
                            No
                        </Button>
                        <Button variant="primary" onClick={() => handleConfirmation(true)}>
                            Yes
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal show={showEditModal} onHide={handleEditModalClose} centered className='addfrom awb_modal'>
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    {modalMode === 'E' ?
                        <AddAWB
                            isModalEdit={true}
                            closeModal={handleEditModalClose}
                            assignData={editmodalData}
                            reloadGrid={reloadGridData}
                        />
                        :
                        <AssignAWB
                            isModal={true}
                            closeModal={handleClose}
                            // assignData={editmodalData}
                            reloadGrid={reloadGridData}
                        />
                    }

                </Modal.Body>
            </Modal>
            <Modal show={reAssignShow} onHide={reAssignHandleClose} centered className='addfrom awb_readdign_modal'>
                <Modal.Header closeButton>
                    <Modal.Title>Reassign AWB</Modal.Title>
                    <p>Reassign AWB [{gridSelectData?.map(item => item.airway_bill).join(', ') || ''}] to a new Scheduled Truck.</p>
                </Modal.Header>
                <Modal.Body>
                    <ul class="px-0">
                        {gridSelectData?.map((item, i) => (
                            <div className="awb_reassign_list">
                                <div className="awb_reassign_crd d-flex justify-content-between align-items-center">
                                    <div className="awb_no_dv">
                                        <h6>AWB No.</h6>
                                        <p>{item.airway_bill}</p>
                                    </div>
                                    <div className="awb_volume">
                                        <h6>Volume</h6>
                                        <p>{item.volume ?? '-'}</p>
                                    </div>
                                    <div className="pieces">
                                        <h6>Pieces</h6>
                                        <p className="piece_txt"><img src={Box} alt="pieces" /><span className="ms-2">{item.pieces ?? '30'}/{item.weight ?? '35'}</span></p>
                                    </div>
                                    <div>
                                        <img
                                            src={TrashRed}
                                            alt="trash_icon"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => handleDeleteAwb(i)}
                                        />
                                    </div>
                                </div>
                            </div>
                        ))}

                        <div className="awb_reassign_crd">
                            {availableScheduleTruck?.map((availableScheduleTruckItem, i) => (
                                <div className='booking_boardpoint_wrap mb-3'>
                                    <div className="booking_no_dv d-flex align-items-center justify-content-between">
                                        <Form>
                                            <Form.Check
                                                type="radio"
                                                name="availableScheduleTruckItem"
                                                label={availableScheduleTruckItem?.bookingtruck_no}
                                                value={availableScheduleTruckItem?.bookingtruck_date_id}
                                                onChange={(e) =>
                                                    handleTruckSelect(
                                                        String(e.target.value),
                                                        availableScheduleTruckItem.departure_date
                                                    )
                                                }
                                                checked={
                                                    String(selectedTrucks?.bookingtruck_date_id) ===
                                                    String(availableScheduleTruckItem?.bookingtruck_date_id)
                                                }
                                            />
                                        </Form>
                                        <h6>{availableScheduleTruckItem.departure_date}</h6>
                                    </div>
                                    <div class="Boardpoint_offpoint_dv d-flex justify-content-between align-items-end">
                                        <div class="boardpoint_station">
                                            <p>Boardpoint</p>
                                            <h5>{availableScheduleTruckItem.board_point}</h5>
                                        </div>
                                        <div class="middlebrd">
                                            <p className="text-center">
                                                <img
                                                    src={CargoTruck}
                                                    alt="blue_flight"
                                                    className='blue_fligh_img'
                                                />
                                            </p>
                                            {/* <p className='connection_tym'>Connection Time: 12:00</p> */}
                                        </div>
                                        <div class="offpoint_station">
                                            <p>Offpoint</p>
                                            <h5>{availableScheduleTruckItem.off_point}</h5>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                    </ul>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className='cancel_btn'>Cancel</Button>
                    <Button variant="primary" className='reassign_btn' onClick={() => handleReassign()}>Reassign</Button>
                </Modal.Footer>
            </Modal>
            <Modal show={showPercentageModal} onHide={handlePercentageModalClose} centered className='addfrom awb_readdign_modal'>
                <Modal.Header closeButton>
                    <Modal.Title>Exceeding Available Capacity</Modal.Title>
                    <p>Assigning this shipment will exceed the palletgroup available capacity. Do you want to continue?</p>
                </Modal.Header>
                <Modal.Body>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className='cancel_btn' onClick={handlePercentageModalClose}>Cancel</Button>
                    <Button variant="primary" className='reassign_btn' onClick={() => handlePalletGroupChange('Y')}>Continue</Button>
                </Modal.Footer>
            </Modal>
            <Modal show={confirmModal} onHide={confirmModalClose} className='raintrac' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h2>Reassign Shipments</h2>
                    <p>
                        Are you sure you want to reassign these shipments to the selected booking truck?
                    </p>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setConfirmModal(false)}>
                        No
                    </Button>
                    <Button variant="primary" onClick={() => handleReassign("yes")}>
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
            <Loader isLoading={loaderModal} />

        </div>
    )
}

export default Planning;
